import * as React from 'react'

interface Props {
  dataQa?: string
  children: React.ReactNode
}

export const Footer: React.FC<Props> = ({ children, dataQa }) => (
  <div className="view-footer" data-qa={dataQa}>
    <div className="view-footer--content">{children}</div>
  </div>
)

export const FooterItem: React.FC<Props> = ({ children, dataQa }) => (
  <div className="view-footer--content--item" data-qa={dataQa}>
    {children}
  </div>
)
